"use client"

import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { FalseIcon, TrueIcon } from "../../utils/commonIcons"
import { ModalComponent, OutPutResult, Spinner, ReusableDataTable, TruckingModal } from '@operations/shared';
import { useEffect, useState } from "react"
import { Typography, Descriptions, Alert, Space, Tag, message, Select, Col, Result, Button, Avatar, Row } from "antd"
import { ExclamationCircleOutlined, SmileOutlined } from "@ant-design/icons"
import { stepperMoving } from "../../stores/actions"
import { getApi, patchApi } from '../../../../shared/src/apis';
import { getPartnersApi } from "../../utils/apisConsts"
import { errorMessage } from "../../utils/commonStringsConsts"
import helper from "../../utils/helper"
const { Title, Text } = Typography

export default function ViewFreePeriodRequests() {
    const offerData = useSelector((state: any) => state.actionsReducer?.offerData)
    const [requestData, setRequestData] = useState<any>([])
    const [visibleModal, setVisibleModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [partners, setPartners] = useState<any[]>([]);
    const [loadPartners, setLoadPartners] = useState(false);
    const [errorMode, setErrorMode] = useState(false)
    const [selectedPartner, setSelectedPartner] = useState();
    const [selectedPartnersOffer, setSelectedPartnersOffer] = useState([]);
    const dispatch = useDispatch();

    const apiLink =
        offerData?.isCompany
            ? `/companies/freePeriod?companyID=${offerData?.offerTypeId}`
            : `/companies/freePeriod/partner?partnerID=${selectedPartner}&serviceGroupID=${offerData?.offerTypeId}`;

    useEffect(() => {
        if (!offerData?.isCompany) storePartners()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offerData?.isCompany])

    const storePartners = async () => {
        try {
            setLoadPartners(true);
            const getPartners: any = await dispatch(getApi(getPartnersApi + offerData?.offerTypeId, {}));
            if (getPartners?.payload?.status !== 200) {
                setLoadPartners(false);
                setErrorMode(true)
                return;
            } else {
                setPartners(getPartners?.payload?.data);
            }
        } catch (error) {
            setErrorMode(true)
        }
        setLoadPartners(false);
    }

    const handleSuspend = (record: any) => {
        setRequestData(record)
        setVisibleModal(true)
    }

    const columns = [
        {
            title: "Suspend action",
            key: "suspend",
            fixed: "left",
            render: (_: any, record: any) => (
                <button
                    onClick={() => !record?.isSuspended && handleSuspend(record)}
                    disabled={record?.isSuspended}
                    style={{
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "6px 12px",
                        cursor: record?.isSuspended ? "not-allowed" : "pointer",
                        fontWeight: 500,
                        opacity: record?.isSuspended ? 0.5 : 1,
                    }}
                >
                    Suspend
                </button>
            ),
        },
        ...(selectedPartner ? [
            {
                title: "Selected Partners",
                key: "partners",
                fixed: "left",
                render: (_: any, record: any) => (
                    <Button type="primary" onClick={() => setSelectedPartnersOffer(record?.partners)}>Partners</Button>
                ),
            },
        ] : []),
        {
            title: "Free Period Request ID",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "isActive",
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive: boolean) => (isActive ? TrueIcon : FalseIcon),
        },
        {
            title: "isSuspended",
            dataIndex: "isSuspended",
            key: "isSuspended",
            render: (isSuspended: boolean) => (isSuspended ? TrueIcon : FalseIcon),
        },
        {
            title: "companyID",
            dataIndex: "companyID",
            key: "companyID",
        },
        {
            title: "numberOfFreeMonths",
            dataIndex: "numberOfFreeMonths",
            key: "numberOfFreeMonths",
        },
        {
            title: "minNumberOfInstallments",
            dataIndex: "minNumberOfInstallments",
            key: "minNumberOfInstallments",
        },
        {
            title: "maxAmountPerUser",
            dataIndex: "maxAmountPerUser",
            key: "maxAmountPerUser",
        },
        {
            title: "maxNumberOfRequestsPerUser",
            dataIndex: "maxNumberOfRequestsPerUser",
            key: "maxNumberOfRequestsPerUser",
        },
        {
            title: "serviceGroupID",
            dataIndex: "serviceGroupID",
            key: "serviceGroupID",
        },
        {
            title: "firstTransactionUser",
            dataIndex: "firstTransactionUser",
            key: "firstTransactionUser",
            render: (firstTransactionUser: boolean) => (firstTransactionUser ? TrueIcon : FalseIcon),
        },
        {
            title: "createdBy",
            dataIndex: "createdBy",
            key: "createdBy",
        },
        {
            title: "Start Date",
            dataIndex: "startDate",
            key: "startDate",
            render: (date: string) => moment(date).format("LL"),
        },
        {
            title: "End Date",
            dataIndex: "endDate",
            key: "endDate",
            render: (date: string) => moment(date).format("LL"),
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date: string) => moment(date).format("LLL"),
        },
        {
            title: "Service Group Name",
            dataIndex: "serviceGroupName",
            key: "serviceGroupName",
        },
        {
            title: "Company Name",
            dataIndex: "companyName",
            key: "companyName",
        },
    ]

    const handleCloseTheModal = () => {
        setVisibleModal(false)
    }

    const handleAcceptModal = async () => {
        setLoading(true)

        if (!requestData?.id) return;
        try {
            const res = await patchApi(`/companies/suspendFreePeriod?id=${requestData?.id}`, {})(() => { });
            if (res?.payload?.status === 200) {
                setVisibleModal(false);
                message.success("Free period request suspended successfully");
                dispatch(stepperMoving(0))
            } else {
                message.error("Failed to suspend free period request")
            }
        } catch (error) {
            // Optionally, handle error (show notification, etc.)
            console.error(error);
        }
        setLoading(false)

    }

    const dropDownSearch = (input: string, option: { children?: string; label?: string; }) => {
        const searchText = option?.label || option?.children || '';
        return searchText.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }

    const suspendMessageContent = (
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <div style={{ textAlign: "center" }}>
                <ExclamationCircleOutlined
                    style={{
                        fontSize: 48,
                        color: "#faad14",
                        marginBottom: 16,
                    }}
                />
                <Title level={4} style={{ margin: 0, color: "#262626" }}>
                    Suspend Free Period Request
                </Title>
                <Text type="secondary">You are about to suspend the following free period request</Text>
            </div>

            {/* Request Details */}
            <Descriptions
                title="Request Details"
                bordered
                column={1}
                size="small"
                labelStyle={{
                    fontWeight: 600,
                    backgroundColor: "#fafafa",
                    width: "40%",
                }}
                contentStyle={{
                    backgroundColor: "#fff",
                    fontWeight: 500,
                }}
            >
                <Descriptions.Item label="Request ID">
                    <Tag color="blue">{requestData?.id}</Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Company Name">
                    <Text strong>{requestData?.companyName}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Service Group">
                    <Text>{requestData?.serviceGroupName}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Free Months">
                    <Tag color="green">{requestData?.numberOfFreeMonths} months</Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Max Amount Per User">
                    <Text code>{requestData?.maxAmountPerUser}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Max Requests Per User">
                    <Text code>{requestData?.maxNumberOfRequestsPerUser}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Start Date">
                    <Text>{requestData?.startDate ? moment(requestData?.startDate).format("LL") : "N/A"}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="End Date">
                    <Text>{requestData?.endDate ? moment(requestData?.endDate).format("LL") : "N/A"}</Text>
                </Descriptions.Item>
            </Descriptions>

            {/* Warning Alert */}
            <Alert
                message="Warning"
                description="Are you sure you want to suspend this request? This action cannot be undone and will immediately deactivate the free period benefits for all associated users."
                type="warning"
                showIcon
                icon={<ExclamationCircleOutlined />}
                style={{
                    borderRadius: 8,
                    border: "1px solid #faad14",
                }}
            />
        </Space>
    )

    return (
        <>
            {errorMode && !offerData?.isCompany ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
                btnTitle={'Refresh the page'} btnClick={helper.refreshPage} />
                : loadPartners ? <Spinner size='large' />
                    :
                    <div
                        style={{ display: "flex", flexDirection: "column", marginTop: "20px", overflowY: "auto" }}
                    >
                        {!offerData?.isCompany &&
                            <Col span={12} style={{ marginBottom: "10px" }}>
                                <label >
                                    Partner <span>*</span>
                                </label>
                                <Select
                                    placeholder="Select Partner"
                                    options={partners?.map((partner: any) => ({ label: partner?.name, value: partner?.id }))}
                                    onChange={(value: any) => setSelectedPartner(value)}
                                    loading={loadPartners}
                                    disabled={loadPartners}
                                    showSearch
                                    allowClear
                                    filterOption={((input, option: any) => dropDownSearch(input, option))}
                                    style={{ width: "100%" }}
                                />
                            </Col>
                        }
                        {!offerData?.isCompany && !selectedPartner ?
                            <Result
                                icon={<SmileOutlined />}
                                title={"Please select a partner to view the offers."}
                            />
                            :
                            <ReusableDataTable
                                key={apiLink}
                                columns={columns}
                                hiddenRefreshing
                                apiLink={apiLink}
                                pagination={false}
                                loading={false}
                                scrolling={{ x: "max-content" }}
                                loadData={true}
                            />}
                    </div>
            }
            <ModalComponent
                content={suspendMessageContent}
                title={`Suspend Free Period Request`}
                visibleModal={visibleModal}
                okText='Suspend'
                handleCloseModal={handleCloseTheModal}
                handleAcceptModal={handleAcceptModal}
                btnDisable={loading}
            />
            <TruckingModal
                visibleModal={selectedPartnersOffer?.length > 0}
                width={
                    selectedPartnersOffer?.length === 1 ? 450 :
                    selectedPartnersOffer?.length === 2 ? 600 :
                    800
                }
                content={
                    <div style={{ padding: '4px' }}>
                        <Row gutter={[12, 12]}>
                            {selectedPartnersOffer?.map((partner: any, index: number) => {
                                const partnersCount = selectedPartnersOffer?.length || 0;
                                
                                let colSpan = 8; 
                                if (partnersCount === 1) {
                                    colSpan = 24; 
                                } else if (partnersCount === 2) {
                                    colSpan = 12; 
                                } else if (partnersCount <= 3) {
                                    colSpan = 8; 
                                } else {
                                    colSpan = 8;
                                }
                                
                                return (
                                    <Col key={partner?.id} xs={24} sm={12} md={colSpan}>
                                        <div
                                            style={{
                                                padding: '16px',
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                border: '1px solid #e8e8e8',
                                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                                                transition: 'all 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.12)';
                                                e.currentTarget.style.borderColor = '#d9d9d9';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.06)';
                                                e.currentTarget.style.borderColor = '#e8e8e8';
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <Avatar
                                                    size={48}
                                                    style={{
                                                        backgroundColor: '#f0f0f0',
                                                        color: '#595959',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    {partner?.name?.charAt(0)?.toUpperCase() || 'P'}
                                                </Avatar>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <Typography.Text 
                                                        strong 
                                                        style={{ 
                                                            fontSize: '15px', 
                                                            display: 'block',
                                                            color: '#262626',
                                                            marginBottom: '6px',
                                                        }}
                                                        ellipsis
                                                    >
                                                        {partner?.name || 'Unknown Partner'}
                                                    </Typography.Text>
                                                    <Tag 
                                                        color="default"
                                                        style={{ 
                                                            fontSize: '11px',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#fafafa',
                                                            color: '#8c8c8c',
                                                            borderColor: '#d9d9d9',
                                                        }}
                                                    >
                                                        ID: {partner?.id || 'N/A'}
                                                    </Tag>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                }
                handleCloseModal={() => setSelectedPartnersOffer([])}
                title={'Partners'}
            />
        </>
    );
}
